import { latLng } from "leaflet";
import axios from "axios"
import router from "./router"
import moment from 'moment'

const store = {
    state: {
        isSidebarOpen: false,
        map: {
            center: latLng(14.601205, 120.974780),
            currentCenter: latLng(14.601205, 120.974780),
        },
        place_list: [],
        place_totalRows: 1000,
        place_perPage: 10,
        place_currentPage: 1,
        place_list_marker_coords: [],
        place_current_hover_id: '',
        gps_longitude: 0, //121.006059646606,
        gps_latitude: 0, //14.4485807418823,
        gps_reverse: {},
        place_radiusMeters: 1000,
        place_current_resource: '',
        auth_userId: '',
        auth_sessionId: '',
        place_id: '',
        place_current_data: {},
        addNewBusiness_response: {
            id: ''
        },
        reviews_currentPage: 1,
        reviews_totalRows: 100,
        reviews_perPage: 10,
        reviews_list: [],
        reviews_retrieving: false,
        place_photos_list: [],
        place_photos_retrieveing: false,
        place_search_suggestion_list: [],
        location_search_suggestion_list: [],
        search_result_retrieving: false,
        search_param: {}
    },
    mutations: {
        TOGGLE_SIDE(state) {
            state.isSidebarOpen = !state.isSidebarOpen
        },
        MAP_SET_CENTER(state, payload) {
            state.map.center = latLng(payload.coords.latitude, payload.coords.longitude)
        },
        MAP_UPDATE_CURRENT_CENTER(state, payload) {
            state.map.currentCenter = payload
        },
        PLACE_LOADLIST(state, payload) {
            state.place_list = payload
        },
        PLACE_SET_CURRENT_PAGE(state, payload) {
            state.place_currentPage = payload
        },
        PLACE_SET_TOTAL_ROWS(state, payload) {
            state.place_totalRows = payload
        },
        PLACE_LOADLISTMARKER(state, payload) {
            state.place_list_marker_coords = payload
        },
        PLACE_SET_CURRENT_HOVER_ID(state, payload) {
            state.place_current_hover_id = payload
        },
        PLACE_SET_CURRENT_RESOURCE(state, payload) {
            state.place_current_resource = payload
        },
        AUTH_SET_USER_ID(state, payload) {
            state.auth_userId = payload
        },
        AUTH_SET_SESSION_ID(state, payload) {
            state.auth_sessionId = payload
        },
        PLACE_SET_ID(state, payload) {
            state.place_id = payload
        },
        PLACE_SET_CURRENT_DATA(state, payload) {
            state.place_current_data = payload
        },
        GPS_SET_COORDS(state, payload) {
            state.gps_longitude = payload.longitude
            state.gps_latitude = payload.latitude
        },
        GPS_SET_REVERSE(state, payload) {
            state.gps_reverse = payload
        },
        SET_ADDNEWBUSINESS_RESPONSE(state, payload) {
            state.addNewBusiness_response.id = payload
        },
        RESET_ADDNEWBUSINESS_RESPONSE(state) {
            state.addNewBusiness_response.id = ''
        },
        REVIEWS_SET_CURRENT_PAGE(state, payload) {
            state.reviews_currentPage = payload
        },
        REVIEWS_SET_TOTAL_ROWS(state, payload) {
            state.reviews_totalRows = payload
        },
        REVIEWS_LOADLIST(state, payload) {
            state.reviews_list = payload
        },
        REVIEWS_RETRIEVING(state, payload) {
            state.reviews_retrieving = payload
        },
        PLACE_PHOTOS_LOADLIST(state, payload) {
            state.place_photos_list = payload
        },
        PLACE_PHOTOS_RETRIEVING(state, payload) {
            state.place_photos_retrieveing = payload
        },
        PLACE_SEARCH_SUGGESTION_LOADLIST(state, payload) {
            state.place_search_suggestion_list = payload
        },
        LOCATION_SEARCH_SUGGESTION_LOADLIST(state, payload) {
            state.location_search_suggestion_list = payload
        },
        SEARCH_RESULT_RETRIEVING(state, payload) {
            state.search_result_retrieving = payload
        },
        SET_SEARCH_PARAM(state, payload) {
            state.search_param = payload
        },
        RESET_SEARCH_PLACE_COUNTERS(state) {
            state.place_currentPage = 1
            state.place_list_marker_coords = []
            state.place_current_resource = ''
        }
    },
    actions: {
        toggleSide(context) {
            context.commit("TOGGLE_SIDE")
        },
        map_setCenter(context, payload) {
            context.commit("MAP_SET_CENTER", payload)
        },
        map_updateCurrentCenter(context, payload) {
            context.commit("MAP_UPDATE_CURRENT_CENTER", payload)
        },
        retrievePlaces(context) {
            var options = { headers: {'Authorization': 'Bearer ' + this._vm.$getAccessToken()} }
            var httpCurrentPage = context.state.place_currentPage - 1
            axios.get(process.env.VUE_APP_PLACE_URL + '?page=' + httpCurrentPage + '&size=' + context.state.place_perPage, options)
                .then(function (response) {
                    console.log(response)
                    var list = []
                    var list_marker = []
                    var responseData = response.data.content
                    var counter = httpCurrentPage * context.state.place_perPage
                    var totalElements = response.data.totalElements
                    console.log(totalElements)
                    context.commit("PLACE_SET_TOTAL_ROWS", totalElements)
                    for(var i in responseData) {
                        counter = counter + 1
                        var x = responseData[i]
                        list.push({
                            localNumber: counter,
                            id: x.id,
                            name: x.name,
                            latitude: x.latitude,
                            longitude: x.longitude,
                            imageUrl: x.imageUrl == '' ? 'https://tacm.com/wp-content/uploads/2018/01/no-image-available.jpeg' : responseData[i].imageUrl,
                            categories: x.categories,
                            price: x.price,
                            locationAddress1: x.locationAddress1,
                            locationAddress2: x.locationAddress2,
                            locationAddress3: x.locationAddress3,
                            locationCity: x.locationCity,
                            locationZip: x.locationZip,
                            locationState: x.locationState,
                            locationCountry: x.locationCountry,
                            phone: x.phone,
                        })

                        // create list for marker
                        list_marker.push({
                            id: x.id,
                            coordinates: [x.longitude, x.latitude ],
                            localNumber: counter
                        })
                    }
                    context.commit("PLACE_LOADLIST", list)
                    context.commit("PLACE_LOADLISTMARKER", list_marker)
                })
                .catch(function (error) {
                    console.log(error)
                })
                .then(function() {

                })
        },
        place_setCurrentPage(context, payload) {
            context.commit("PLACE_SET_CURRENT_PAGE", payload)
        },
        place_setCurrentHoverId(context, payload) {
            context.commit("PLACE_SET_CURRENT_HOVER_ID", payload)
        },
        retrievePlacesPopular(context) {
            context.commit("PLACE_SET_CURRENT_RESOURCE", "popular")
            var options = { headers: {'Authorization': 'Bearer ' + this._vm.$getAccessToken()} }
            var httpCurrentPage = context.state.place_currentPage - 1
            axios.get(process.env.VUE_APP_PLACE_URL + '/popular', options)
                .then(function (response) {
                    console.log(response)
                    var list = []
                    var list_marker = []
                    var responseData = response.data.content
                    var counter = httpCurrentPage * context.state.place_perPage
                    var totalElements = response.data.totalElements
                    console.log(totalElements)
                    context.commit("PLACE_SET_TOTAL_ROWS", totalElements)
                    for(var i in responseData) {
                        counter = counter + 1
                        var x = responseData[i]
                        list.push({
                            localNumber: counter,
                            id: x.id,
                            name: x.name,
                            latitude: x.latitude,
                            longitude: x.longitude,
                            imageUrl: x.imageUrl == '' ? 'https://tacm.com/wp-content/uploads/2018/01/no-image-available.jpeg' : responseData[i].imageUrl,
                            categories: x.categories,
                            price: x.price,
                            locationAddress1: x.locationAddress1,
                            locationAddress2: x.locationAddress2,
                            locationAddress3: x.locationAddress3,
                            locationCity: x.locationCity,
                            locationZip: x.locationZip,
                            locationState: x.locationState,
                            locationCountry: x.locationCountry,
                            phone: x.phone,
                            numberOfRatings: x.numberOfRatings,
                            averageRating: x.averageRating,
                            numberOfPhotos: x.numberOfPhotos
                        })

                        // create list for marker
                        list_marker.push({
                            id: x.id,
                            coordinates: [x.longitude, x.latitude ],
                            localNumber: counter
                        })
                    }
                    context.commit("PLACE_LOADLIST", list)
                    context.commit("PLACE_LOADLISTMARKER", list_marker)
                })
                .catch(function (error) {
                    console.log(error)
                })
                .then(function() {

                })
        },
        retrievePlacesNearYou(context) {
            context.commit("PLACE_SET_CURRENT_RESOURCE", "nearyou")
            var options = { headers: {'Authorization': 'Bearer ' + this._vm.$getAccessToken()} }
            var httpCurrentPage = context.state.place_currentPage - 1
            axios.get(process.env.VUE_APP_PLACE_URL + '/nearyou' 
                + '?page=' + httpCurrentPage 
                + '&size=' + context.state.place_perPage 
                + '&longitude=' + context.state.gps_longitude
                + '&latitude=' + context.state.gps_latitude
                + '&meters=' + context.state.place_radiusMeters
                , options)
                .then(function (response) {
                    console.log(response)
                    var list = []
                    var list_marker = []
                    var responseData = response.data.content
                    var counter = httpCurrentPage * context.state.place_perPage
                    var totalElements = response.data.totalElements
                    console.log(totalElements)
                    context.commit("PLACE_SET_TOTAL_ROWS", totalElements)
                    for(var i in responseData) {
                        counter = counter + 1
                        var x = responseData[i]
                        list.push({
                            localNumber: counter,
                            id: x.id,
                            name: x.name,
                            latitude: x.latitude,
                            longitude: x.longitude,
                            imageUrl: x.imageUrl == '' ? 'https://tacm.com/wp-content/uploads/2018/01/no-image-available.jpeg' : responseData[i].imageUrl,
                            categories: x.categories,
                            price: x.price,
                            locationAddress1: x.locationAddress1,
                            locationAddress2: x.locationAddress2,
                            locationAddress3: x.locationAddress3,
                            locationCity: x.locationCity,
                            locationZip: x.locationZip,
                            locationState: x.locationState,
                            locationCountry: x.locationCountry,
                            phone: x.phone,
                            numberOfRatings: x.numberOfRatings,
                            averageRating: x.averageRating,
                            numberOfPhotos: x.numberOfPhotos
                        })

                        // create list for marker
                        list_marker.push({
                            id: x.id,
                            coordinates: [x.longitude, x.latitude ],
                            localNumber: counter
                        })
                    }
                    context.commit("PLACE_LOADLIST", list)
                    context.commit("PLACE_LOADLISTMARKER", list_marker)
                })
                .catch(function (error) {
                    console.log(error)
                })
                .then(function() {

                })
        },
        retrievePlacesForYou(context) {
            context.commit("PLACE_SET_CURRENT_RESOURCE", "foryou")
            var options = { headers: {'Authorization': 'Bearer ' + this._vm.$getAccessToken()} }
            var httpCurrentPage = context.state.place_currentPage - 1
            axios.get(process.env.VUE_APP_PLACE_URL + '/implicit/' + context.state.auth_userId, options)
            .then(function (response) {
                console.log(response)
                var list = []
                var list_marker = []
                var responseData = response.data.content
                var counter = httpCurrentPage * context.state.place_perPage
                var totalElements = response.data.totalElements
                console.log(totalElements)
                context.commit("PLACE_SET_TOTAL_ROWS", totalElements)
                for(var i in responseData) {
                    counter = counter + 1
                    var x = responseData[i]
                    list.push({
                        localNumber: counter,
                        id: x.id,
                        name: x.name,
                        latitude: x.latitude,
                        longitude: x.longitude,
                        imageUrl: x.imageUrl == '' ? 'https://tacm.com/wp-content/uploads/2018/01/no-image-available.jpeg' : responseData[i].imageUrl,
                        categories: x.categories,
                        price: x.price,
                        locationAddress1: x.locationAddress1,
                        locationAddress2: x.locationAddress2,
                        locationAddress3: x.locationAddress3,
                        locationCity: x.locationCity,
                        locationZip: x.locationZip,
                        locationState: x.locationState,
                        locationCountry: x.locationCountry,
                        phone: x.phone,
                        numberOfRatings: x.numberOfRatings,
                        averageRating: x.averageRating,
                        numberOfPhotos: x.numberOfPhotos
                    })

                    // create list for marker
                    list_marker.push({
                        id: x.id,
                        coordinates: [x.longitude, x.latitude ],
                        localNumber: counter
                    })
                }
                context.commit("PLACE_LOADLIST", list)
                context.commit("PLACE_LOADLISTMARKER", list_marker)
            })
            .catch(function (error) {
                console.log(error)
            })
            .then(function() {

            })
        },
        sendEvidence(context, payload) {
            console.log(context)
            console.log(payload)
            // TODO: find a good place to make api calls not involving change in state
            var options = { headers: {'Authorization': 'Bearer ' + this._vm.$getAccessToken()} }
            var data = {
                user_id: context.state.auth_userId,
                content_id: payload.content_id,
                event: payload.event,
                session_id: context.state.auth_sessionId
            }
            console.log(data)
            axios.post(process.env.VUE_APP_COLLECTOR_URL + '/evidence', data, options)
            .then(function (response) {
                console.log('got response from collector')
                console.log(response)
            })
            .catch(function (error) {
                console.log(error)
            })
            .then(function() {

            })
        },
        setAuthUserId(context, payload) {
            context.commit("AUTH_SET_USER_ID", payload)
        },
        setAuthSessionId(context, payload) {
            context.commit("AUTH_SET_SESSION_ID", payload)
        },
        setPlaceId(context, payload) {
            context.commit("PLACE_SET_ID", payload)
        },
        retrievePlace(context, payload) {
            context.commit("PLACE_SET_ID", payload)
            var options = { headers: {'Authorization': 'Bearer ' + this._vm.$getAccessToken()} }
            axios.get(process.env.VUE_APP_PLACE_URL + '/' + payload, options)
            .then(function (response) {
                console.log(response.data)
                context.commit("PLACE_SET_CURRENT_DATA", response.data)
            })
            .catch(function (error) {
                console.log(error)
            })
            .then(function() {

            })
        },
        setGPS(context, payload) {
            console.log('updating gps in state', payload)
            context.commit("GPS_SET_COORDS", payload)
        },
        saveAddNewBusiness(context, payload) {
            // just call it so compiler dont complain its not being used
            context
            var options = { headers: {'Authorization': 'Bearer ' + this._vm.$getAccessToken()} }
            axios.post(process.env.VUE_APP_PLACE_URL, payload, options)
            .then(function (response) {
                console.log('got response from place')
                console.log(response)
                context.commit("SET_ADDNEWBUSINESS_RESPONSE", response.data.id)
            })
            .catch(function (error) {
                console.log(error)
            })
            .then(function() {
            })
        },
        resetAddNewBusiness(context) {
            context.commit("RESET_ADDNEWBUSINESS_RESPONSE")
        },
        postReview(context, payload) {
            context
            console.log('going to new page...')
            console.log('placeId: ', payload.placeId)
            var options = { headers: {'Authorization': 'Bearer ' + this._vm.$getAccessToken()} }
            let formData = new FormData()
            for (let i=0; i<payload.files.length; i++) {
                formData.append("files", payload.files[i])
            }
            formData.append("placeId", payload.placeId)
            formData.append("userId", context.state.auth_userId)
            formData.append("star", payload.star)
            formData.append("text", payload.text)
            axios.post(process.env.VUE_APP_RATING_URL + '/rating/withFiles', formData, options)
            .then(function (response) {
                console.log('got response from rating')
                console.log(response)
                router.push({
                    name: 'Place',
                    params: {
                        id: payload.placeId
                    }
                })
            })
            .catch(function (error) {
                console.log(error)
            })
            .then(function() {

            })
        },
        reviews_setCurrentPage(context, payload) {
            context.commit("REVIEWS_SET_CURRENT_PAGE", payload)
        },
        retrieveReviews(context) {
            context.commit("REVIEWS_RETRIEVING", true)
            var options = { headers: {'Authorization': 'Bearer ' + this._vm.$getAccessToken()} }
            var httpCurrentPage = context.state.reviews_currentPage - 1
            
            var list = []
            context.commit("REVIEWS_LOADLIST", list)

            axios.get(process.env.VUE_APP_RATING_URL + '/rating/place/' + context.state.place_id + '?page=' + httpCurrentPage + '&size=' + context.state.reviews_perPage, options)
            .then(function (response) {
                console.log(response)
                var responseData = response.data.content
                var counter = httpCurrentPage * context.state.reviews_perPage
                var totalElements = response.data.totalElements
                console.log(totalElements)
                context.commit("REVIEWS_SET_TOTAL_ROWS", totalElements)
                for(var i in responseData) {
                    counter = counter + 1
                    var x = responseData[i]
                    var dateCreated = moment(x.created).format('l');
                    list.push({
                        created: dateCreated,
                        id: x.id,
                        photos: x.photos,
                        placeId: x.placeId,
                        star: x.star,
                        text: x.text,
                        user: x.user,
                        localNumber: counter
                    })
                }
                console.log('length of reviews retrieved is', list.length)
                context.commit("REVIEWS_LOADLIST", list)
            })
            .catch(function (error) {
                console.log(error)
            })
            .then(function() {
                context.commit("REVIEWS_RETRIEVING", false)
            })
        },
        retrievePlacePhotos(context) {
            context.commit("PLACE_PHOTOS_RETRIEVING", true)
            var options = { headers: {'Authorization': 'Bearer ' + this._vm.$getAccessToken()} }

            var list = []
            var counter = 0;
            context.commit("PLACE_PHOTOS_LOADLIST", list)

            axios.get(process.env.VUE_APP_ASSET_URL + '/photo/place/' + context.state.place_id, options)
            .then(function (response) {
                console.log(response)
                var responseData = response.data
                for(var i in responseData) {
                    var x = responseData[i]
                    x.counter = counter++
                    x.created = moment(x.created).format('LL');
                    console.log(x)
                    list.push(x)
                }
                console.log('length of photos', list.length)
                context.commit("PLACE_PHOTOS_LOADLIST", list)
            })
            .catch(function (error) {
                console.log(error)
            })
            .then(function() {
                context.commit("PLACE_PHOTOS_RETRIEVING", false)
            })
        },
        retrievePlaceSuggestions(context, payload) {
            var options = { headers: {'Authorization': 'Bearer ' + this._vm.$getAccessToken()} }
            var list = []
            axios.post(process.env.VUE_APP_PLACE_SEARCH_URL + '/suggestName', payload, options)
            .then(function (response) {
                var responseData = response.data.items
                for(var i in responseData) {
                    var x = responseData[i]
                    console.log(x)
                    if (x.type == 'NAME') {
                        // if no imgLink, set default image
                        if (x.imgLink === '') {
                            x.imgLink = 'https://www.iconpacks.net/icons/1/free-building-icon-1062-thumb.png'
                        }
                        list.push({
                            type: x.type,
                            id: x.id,
                            mainText: x.name,
                            imgLink: x.imgLink,
                            subText: x.address
                        })
                    } else if (x.type == 'TAG') {
                        list.push({
                            type: x.type,
                            id: x.id,
                            mainText: x.name
                        })
                    }
                }
                console.log('length of suggestions', list.length)
                console.log(list)
                context.commit("PLACE_SEARCH_SUGGESTION_LOADLIST", list)
            })
            .catch(function (error) {
                console.log(error)
            })
            .then(function() {
                
            })
            
        },
        retrieveLocationSuggestions(context, payload) {
            var options = { headers: {'Authorization': 'Bearer ' + this._vm.$getAccessToken()} }
            var list = []
            var postPayload = {
                text: payload
            }
            axios.post(process.env.VUE_APP_PLACE_SEARCH_URL + '/suggestLocation', postPayload, options)
            .then(function (response) {
                var responseData = response.data.items
                for(var i in responseData) {
                    var x = responseData[i]
                    console.log(x)
                    if (x.type == 'LOCATION') {
                        list.push({
                            type: x.type,
                            id: x.id,
                            mainText: x.display
                        })
                    }
                }
                console.log('length of suggestions', list.length)
                console.log(list)
                context.commit("LOCATION_SEARCH_SUGGESTION_LOADLIST", list)
            })
            .catch(function (error) {
                console.log(error)
            })
            .then(function() {
                
            })
        },
        retrieveGPSReverse(context) {
            var options = { headers: {'Authorization': 'Bearer ' + this._vm.$getAccessToken()} }
            axios.get(process.env.VUE_APP_PLACE_UTILS_URL + '/reverse?latitude=' + context.state.gps_latitude + '&longitude=' + context.state.gps_longitude, options)
            .then(function (response) {
                var responseData = response.data
                var reverse = {
                    city: responseData.city,
                    state: responseData.state,
                    country: responseData.country,
                    display: responseData.display
                }
                console.log('setting GPS_SET_REVERSE to: ', reverse)
                context.commit("GPS_SET_REVERSE", reverse)
            })
            .catch(function (error) {
                console.log(error)
            })
            .then(function() {
                
            })
        },
        clearGPSReverse(context) {
            console.log('updating gps reverse in state')
            context.commit("GPS_SET_REVERSE", {})
        },
        retrieveGPSusingIP(context) {
            var options = { headers: {
                'Authorization': 'Bearer ' + this._vm.$getAccessToken()} }
            axios.get('https://cors-anywhere.herokuapp.com/http://api.ipify.org/?format=text', options)
            .then(function (response) {
                var ipaddress = response.data
                console.log('received ip is: ', ipaddress)
                axios.get(process.env.VUE_APP_PLACE_UTILS_URL + '/reverse?ipaddress=' + ipaddress, options)
                .then(function (response) {
                    var responseData = response.data
                    var reverse = {
                        city: responseData.city,
                        state: responseData.state,
                        country: responseData.country,
                        display: responseData.display
                    }
                    console.log('setting GPS_SET_REVERSE to: ', reverse)
                    context.commit("GPS_SET_REVERSE", reverse)
                })
                .catch(function (error) {
                    console.log(error)
                })
                .then(function() {
                    
                })
            })
            .catch(function (error) {
                console.log(error)
            })
            .then(function() {
                
            })
        },
        resetSearchPlaceCounters(context) {
            context.commit('RESET_SEARCH_PLACE_COUNTERS')
        },
        retrievePlacesSearch(context, payload) {
            console.log('retrievePlacesSearch...', payload)
            context.commit('SET_SEARCH_PARAM', payload)
            context.commit('SEARCH_RESULT_RETRIEVING', true)
            context.commit("PLACE_SET_CURRENT_RESOURCE", "search")
            var options = { headers: {'Authorization': 'Bearer ' + this._vm.$getAccessToken()} }
            var httpCurrentPage = context.state.place_currentPage - 1
            payload.page = httpCurrentPage
            payload.size = context.state.place_perPage 
            axios.post(process.env.VUE_APP_PLACE_SEARCH_URL + '/places', payload, options)
            .then(function (response) {
                console.log(response)
                var list = []
                var list_marker = []
                var responseData = response.data.content
                var counter = httpCurrentPage * context.state.place_perPage
                var totalElements = response.data.totalElements
                console.log(totalElements)
                context.commit("PLACE_SET_TOTAL_ROWS", totalElements)
                for(var i in responseData) {
                    counter = counter + 1
                    var x = responseData[i]
                    list.push({
                        localNumber: counter,
                        id: x.id,
                        name: x.name,
                        latitude: x.latitude,
                        longitude: x.longitude,
                        imageUrl: x.imageUrl == '' ? 'https://tacm.com/wp-content/uploads/2018/01/no-image-available.jpeg' : responseData[i].imageUrl,
                        categories: x.categories,
                        price: x.price,
                        locationAddress1: x.locationAddress1,
                        locationAddress2: x.locationAddress2,
                        locationAddress3: x.locationAddress3,
                        locationCity: x.locationCity,
                        locationZip: x.locationZip,
                        locationState: x.locationState,
                        locationCountry: x.locationCountry,
                        phone: x.phone,
                        numberOfRatings: x.numberOfRatings,
                        averageRating: x.averageRating,
                        numberOfPhotos: x.numberOfPhotos
                    })

                    // create list for marker
                    list_marker.push({
                        id: x.id,
                        coordinates: [x.longitude, x.latitude ],
                        localNumber: counter
                    })
                }
                context.commit("PLACE_LOADLIST", list)
                context.commit("PLACE_LOADLISTMARKER", list_marker)
            })
            .catch(function (error) {
                console.log(error)
            })
            .then(function() {
                context.commit('SEARCH_RESULT_RETRIEVING', false)
            })
        },
        setSearchResultRetrieving(context, payload) {
            context.commit('SEARCH_RESULT_RETRIEVING', payload)
        }
    }
}

export default store